import Vue from "vue";
import Router from "vue-router";
import Web from "@/views/Web/Web";
import Embedded from "@/views/Embedded/Embedded.vue";
import UserExternalNotifications from "@/components/pages/Users/UserExternalNotifications.vue";
import UserCustomSignature from "@/components/pages/Users/UserCustomSignature.vue";
import store from "@/store";
import { webAuth } from "@/auth";
import { buildRoutesObject } from "@/lib/utilities/helpers/navigation";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/web",
      component: Web,
      // If you need to do something custom, set `route.meta.customRouterHandling = true` and specify the route here.
      children: [...buildRoutesObject()],
    },
    {
      path: "/embedded",
      component: Embedded,
      children: [
        {
          path: "userexternalnotifications",
          component: UserExternalNotifications
        },
        {
          path:"usercustomsignature",
          component : UserCustomSignature
        }
      ]
    },
    {
      path: "*",
      redirect: "/web"
    },
  ],
});

async function onChange(to, from, next) {
  const reqs = [];
  if (!store.getters.User.UserId) {
    reqs.push(store.dispatch("getCurrentUser"));
  }
  reqs.push(webAuth.getOAuthUser());

  await Promise.all(reqs);
  if (next) next();
}

router.beforeEach(onChange);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js